import classnames from 'classnames';
import React from 'react';

import { ButtonSize, ButtonVariant } from './Button';

export interface IButtonProps {
    children: React.ReactNode;
    size: ButtonSize;
    variant?: ButtonVariant;
    disabled?: boolean;
    className?: string;
    href: string;
    target?: string;
    rel?: string;
    onClick?: () => void;
}

export const ButtonLink = (props: IButtonProps) => {
    const buttonClassNames = classnames(
        'Button',
        props.disabled && 'Button--Disabled',
        `Button--${ButtonSize[props.size]}`,
        `Button--${ButtonVariant[props.variant || ButtonVariant.Primary]}`,
        props.className
    );

    return (
        <a target={props.target} href={props.href} rel={props.rel} className={buttonClassNames} onClick={props.onClick}>
            {props.children}
        </a>
    );
};
